import script from "./Channels.vue?vue&type=script&setup=true&lang=ts"
export * from "./Channels.vue?vue&type=script&setup=true&lang=ts"

import "./Channels.vue?vue&type=style&index=0&id=7d5348bb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5348bb"]])

export default __exports__